<script>
    import { beforeUpdate } from 'svelte';
    import _ from 'lodash';

    // import { tldata } from '@store/stores';
    import { URL_APPEND } from '@general/constants';
    import Input from '@general/myInput.svelte';
    import Loading from '@general/loading.svelte';
    import { postFormData, postData, getData, updateData } from '@general/myAxios';

    import Entry from './entry.svelte';

    export let currentRoute
    const params = {}
    let prevpath = ''
    // import {
    //     Button,
    //     Modal,
    //     ModalBody,
    //     ModalFooter,
    //     ModalHeader
    // } from 'sveltestrap';

    let tl_title = '', title_page_id, tl_title_err = '', isloading = false, update = false, isEditLoading = false, uuid = ''
    let itemsData = {}, items = [], files = []

    beforeUpdate(() => {
        const { path, childRoute } = currentRoute;
        // debugger
        if (prevpath == path) return;

        if (childRoute) {
            isEditLoading = true

            getData('/details/' + childRoute.namedParams.uuid).then(res => {
                let editdata = composeJson(res.data[0]);
                tl_title = res.data[0].title;
                uuid = res.data[0].uuid;

                // console.log('@ editdata ', editdata)

                editdata.data.map((d, i) => {
                    items = [...items, { id: i + 1 }];
                    itemsData[i + 1] = d.media.type == 'link' ? {
                        ...d,
                        url_link: d?.media?.url,
                        start_dt: `${d.start_date.year}-${d.start_date.month}-${d.start_date.day}`
                    } : {
                        ...d,
                        start_dt: `${d.start_date.year}-${d.start_date.month}-${d.start_date.day}`
                    }

                    if (d.is_title_page) title_page_id = i + 1
                })

                isEditLoading = false
            });

            prevpath = path;
            update = true;
        }

    })

    let composeJson = ({ title, uuid, data, timelineimages }) => {
        //assign url links
        let linkedData = data.map(obj => {

            let newmedia = obj.media.type == 'img' ? {
                ...obj.media,
                url_href: timelineimages.find(tl => tl.name == obj.media.url)?.image
            } : { ...obj.media }

            return { ...obj, media: { ...newmedia } }
        })

        return {
            title, uuid, data: linkedData
        }

    }

    let addItem = () => {
        let ids = items.length == 0 ? [0] : items.map(o => o.id)
        items = [...items, { id: Math.max(...ids) + 1, isadd: true }]

    }

    let deleteItem = (key) => {
        if (confirm('Delete timeline item?')) {
            items = items.filter(k => k.id !== key)
            delete itemsData[key]
        }
    }

    let updateItemsData = (key, file = null, obj) => {
        if (itemsData[key] == undefined)
            itemsData[key] = obj
        else
            itemsData = { ...itemsData, [key]: obj }
        // Object.assign(itemsData[key], obj)

        if (file !== null && file.image !== null)
            files = [...files, file]

        files = _.uniqBy(files, 'name')
    }

    let saveItems = () => {
        if (tl_title == '') {
            tl_title_err = 'Please add a timeline title';
            return;
        } else tl_title_err = '';

        items.map(itm => {
            document.getElementById('form' + itm.id).dispatchEvent(new Event("submit", { cancelable: true }))
        })

        setTimeout(function () {
            if (items.length == 0) return;
            if (items.length !== Object.values(itemsData).length) return;
            if (Object.values(itemsData).length <= 1) {
                alert('To add timeline, you must have 2 or more items');
                return;
            }

            let mdl = {
                title: tl_title,
                files,
                data: Object.values(itemsData)
            }

            isloading = true;

            if (update) {
                updateData(`/update/${uuid}`, mdl).then(res => {
                    window.location.href = location.origin + '/highlights/view'
                })
            }
            else {
                postData('/create', mdl).then(res => {
                    // window.location.href = location.origin + '/timeline'
                    window.location.href = location.origin + '/highlights/view'
                })
            }

        }, 300);

    }

    let open = false
    const toggle = () => (open = !open);
</script>

<style>
    .btn2 {
        background-color: transparent;
        border: 0;
        cursor: pointer;
        font-size: 100px;
        font-weight: bold;
        width: 100%;
        height: 100%;
    }

    .error {
        color: red;
    }
</style>

{#if isEditLoading}
<Loading />
{:else}
<div class='row'>
    <div class='col-md-12'>
        <center>
            <div style="display: flex; flex-direction: row; width: 400px; height: 38px;">

                <!-- <Input type='dropdown' bind:selected={tl_title} placeholder="Select Timeline..." options={$titles.map(t=>({ value:
        t, text: t }))} /> -->
                <div>
                    <Input bind:nameval={tl_title} placeholder="* Timeline title" />
                    {#if tl_title_err !== ''}
                    <small class="error">{tl_title_err}</small>
                    {/if}
                </div>
                &nbsp;
                <button class="btn btn-danger" on:click={saveItems} disabled={isloading}>
                    {#if isloading}
                    Loading...
                    {:else}
                    Save
                    {/if}
                </button>

            </div>
        </center>
    </div>
</div>


<div class='row' style="margin-top: 15px;">
    {#each items as item (item.id)}
    <div class='col-md-4'>

        <Entry key={item.id} {updateItemsData} {deleteItem} {update} editData={itemsData[item.id]} isadd={item.isadd}
            imgUrl={itemsData[item.id]?.media?.url_href} initFileName={itemsData[item.id]?.media?.url}
            is_title_page={itemsData[item.id]?.is_title_page}>
            <label>
                {#if !item.isadd}
                    <input type=radio bind:group={title_page_id} value={item.id} on:change={()=>{
                        Object.keys(itemsData).map(k=>{ itemsData[k] = {...itemsData[k], is_title_page: false} })
                        itemsData[item.id] = {...itemsData[item.id], is_title_page: title_page_id == item.id }
                    }}>
                {/if}
                Title Page
            </label>
        </Entry>
    </div>
    {/each}

    <div class="col-md-4">
        <div class='card ' style="margin: 1px; height: 600px; min-height: 600px;  position: relative;">
            <div class='card-body align-items-center d-flex justify-content-center'>
                <button on:click={addItem} class="btn2">
                    +
                </button>
            </div>
        </div>
    </div>

</div>

{/if}